function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

!function t(e, n) {
  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) ? module.exports = n(require("quill")) : "function" == typeof define && define.amd ? define(["quill"], n) : "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? exports.quillTable = n(require("quill")) : e.quillTable = n(e.quill);
}(this, function (t) {
  return function (t) {
    function e(r) {
      if (n[r]) return n[r].exports;
      var o = n[r] = {
        i: r,
        l: !1,
        exports: {}
      };
      return t[r].call(o.exports, o, o.exports, e), o.l = !0, o.exports;
    }

    var n = {};
    return e.m = t, e.c = n, e.d = function (t, n, r) {
      e.o(t, n) || Object.defineProperty(t, n, {
        configurable: !1,
        enumerable: !0,
        get: r
      });
    }, e.n = function (t) {
      var n = t && t.__esModule ? function e() {
        return t.default;
      } : function e() {
        return t;
      };
      return e.d(n, "a", n), n;
    }, e.o = function (t, e) {
      return Object.prototype.hasOwnProperty.call(t, e);
    }, e.p = "", e(e.s = 57);
  }([function (t, e) {
    var n = t.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
    "number" == typeof __g && (__g = n);
  }, function (t, e) {
    var n = t.exports = {
      version: "2.5.1"
    };
    "number" == typeof __e && (__e = n);
  }, function (t, e, n) {
    var r = n(0),
        o = n(1),
        i = n(42),
        a = n(9),
        u = "prototype",
        l = function l(t, e, n) {
      var c = t & l.F,
          s = t & l.G,
          f = t & l.S,
          p = t & l.P,
          d = t & l.B,
          h = t & l.W,
          b = s ? o : o[e] || (o[e] = {}),
          v = b[u],
          g = s ? r : f ? r[e] : (r[e] || {})[u],
          y,
          m,
          _;

      s && (n = e);

      for (y in n) {
        (m = !c && g && void 0 !== g[y]) && y in b || (_ = m ? g[y] : n[y], b[y] = s && "function" != typeof g[y] ? n[y] : d && m ? i(_, r) : h && g[y] == _ ? function (t) {
          var e = function e(_e, n, r) {
            if (this instanceof t) {
              switch (arguments.length) {
                case 0:
                  return new t();

                case 1:
                  return new t(_e);

                case 2:
                  return new t(_e, n);
              }

              return new t(_e, n, r);
            }

            return t.apply(this, arguments);
          };

          return e[u] = t[u], e;
        }(_) : p && "function" == typeof _ ? i(Function.call, _) : _, p && ((b.virtual || (b.virtual = {}))[y] = _, t & l.R && v && !v[y] && a(v, y, _)));
      }
    };

    l.F = 1, l.G = 2, l.S = 4, l.P = 8, l.B = 16, l.W = 32, l.U = 64, l.R = 128, t.exports = l;
  }, function (t, e, n) {
    var r = n(12),
        o = n(43),
        i = n(23),
        a = Object.defineProperty;
    e.f = n(4) ? Object.defineProperty : function t(e, n, u) {
      if (r(e), n = i(n, !0), r(u), o) try {
        return a(e, n, u);
      } catch (t) {}
      if ("get" in u || "set" in u) throw TypeError("Accessors not supported!");
      return "value" in u && (e[n] = u.value), e;
    };
  }, function (t, e, n) {
    t.exports = !n(10)(function () {
      return 7 != Object.defineProperty({}, "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e) {
    var n = {}.hasOwnProperty;

    t.exports = function (t, e) {
      return n.call(t, e);
    };
  }, function (t, e, n) {
    var r = n(75),
        o = n(17);

    t.exports = function (t) {
      return r(o(t));
    };
  }, function (t, e, n) {
    "use strict";

    e.__esModule = !0, e.default = function (t, e) {
      if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function");
    };
  }, function (e, n) {
    e.exports = t;
  }, function (t, e, n) {
    var r = n(3),
        o = n(16);
    t.exports = n(4) ? function (t, e, n) {
      return r.f(t, e, o(1, n));
    } : function (t, e, n) {
      return t[e] = n, t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      try {
        return !!t();
      } catch (t) {
        return !0;
      }
    };
  }, function (t, e, n) {
    var r = n(25)("wks"),
        o = n(18),
        i = n(0).Symbol,
        a = "function" == typeof i;
    (t.exports = function (t) {
      return r[t] || (r[t] = a && i[t] || (a ? i : o)("Symbol." + t));
    }).store = r;
  }, function (t, e, n) {
    var r = n(13);

    t.exports = function (t) {
      if (!r(t)) throw TypeError(t + " is not an object!");
      return t;
    };
  }, function (t, e) {
    t.exports = function (t) {
      return "object" == _typeof(t) ? null !== t : "function" == typeof t;
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(67),
      __esModule: !0
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.__esModule = !0;
    var o = n(41),
        i = r(o);

    e.default = function () {
      function t(t, e) {
        for (var n = 0; n < e.length; n++) {
          var r = e[n];
          r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), (0, i.default)(t, r.key, r);
        }
      }

      return function (e, n, r) {
        return n && t(e.prototype, n), r && t(e, r), e;
      };
    }();
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        enumerable: !(1 & t),
        configurable: !(2 & t),
        writable: !(4 & t),
        value: e
      };
    };
  }, function (t, e) {
    t.exports = function (t) {
      if (void 0 == t) throw TypeError("Can't call method on  " + t);
      return t;
    };
  }, function (t, e) {
    var n = 0,
        r = Math.random();

    t.exports = function (t) {
      return "Symbol(".concat(void 0 === t ? "" : t, ")_", (++n + r).toString(36));
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.__esModule = !0;
    var o = n(48),
        i = r(o);

    e.default = function (t, e) {
      if (!t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      return !e || "object" !== (void 0 === e ? "undefined" : (0, i.default)(e)) && "function" != typeof e ? t : e;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.__esModule = !0;
    var o = n(14),
        i = r(o),
        a = n(94),
        u = r(a);

    e.default = function t(e, n, r) {
      null === e && (e = Function.prototype);
      var o = (0, u.default)(e, n);

      if (void 0 === o) {
        var a = (0, i.default)(e);
        return null === a ? void 0 : t(a, n, r);
      }

      if ("value" in o) return o.value;
      var l = o.get;
      if (void 0 !== l) return l.call(r);
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.__esModule = !0;
    var o = n(97),
        i = r(o),
        a = n(101),
        u = r(a),
        l = n(48),
        c = r(l);

    e.default = function (t, e) {
      if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function, not " + (void 0 === e ? "undefined" : (0, c.default)(e)));
      t.prototype = (0, u.default)(e && e.prototype, {
        constructor: {
          value: t,
          enumerable: !1,
          writable: !0,
          configurable: !0
        }
      }), e && (i.default ? (0, i.default)(t, e) : t.__proto__ = e);
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = n(14),
        i = r(o),
        a = n(7),
        u = r(a),
        l = n(15),
        c = r(l),
        s = n(19),
        f = r(s),
        p = n(20),
        d = r(p),
        h = n(21),
        b = r(h),
        v = n(8),
        g = r(v),
        y = g.default.import("blots/container"),
        m = g.default.import("blots/block"),
        _ = g.default.import("blots/block/embed"),
        x = g.default.import("parchment"),
        A = function (t) {
      function e() {
        return (0, u.default)(this, e), (0, f.default)(this, (e.__proto__ || (0, i.default)(e)).apply(this, arguments));
      }

      return (0, b.default)(e, t), (0, c.default)(e, [{
        key: "formats",
        value: function t(e) {
          return e ? e.tagName : this.domNode.tagName;
        }
      }], [{
        key: "create",
        value: function t(n) {
          return (0, d.default)(e.__proto__ || (0, i.default)(e), "create", this).call(this, n);
        }
      }]), e;
    }(y);

    A.blotName = "contain", A.tagName = "contain", A.scope = x.Scope.BLOCK_BLOT, A.defaultChild = "block", A.allowedChildren = [m, _, y], e.default = A;
  }, function (t, e, n) {
    var r = n(13);

    t.exports = function (t, e) {
      if (!r(t)) return t;
      var n, o;
      if (e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
      if ("function" == typeof (n = t.valueOf) && !r(o = n.call(t))) return o;
      if (!e && "function" == typeof (n = t.toString) && !r(o = n.call(t))) return o;
      throw TypeError("Can't convert object to primitive value");
    };
  }, function (t, e, n) {
    var r = n(25)("keys"),
        o = n(18);

    t.exports = function (t) {
      return r[t] || (r[t] = o(t));
    };
  }, function (t, e, n) {
    var r = n(0),
        o = "__core-js_shared__",
        i = r[o] || (r[o] = {});

    t.exports = function (t) {
      return i[t] || (i[t] = {});
    };
  }, function (t, e) {
    var n = Math.ceil,
        r = Math.floor;

    t.exports = function (t) {
      return isNaN(t = +t) ? 0 : (t > 0 ? r : n)(t);
    };
  }, function (t, e) {
    t.exports = !0;
  }, function (t, e) {
    t.exports = {};
  }, function (t, e, n) {
    var r = n(12),
        o = n(74),
        i = n(31),
        a = n(24)("IE_PROTO"),
        u = function u() {},
        l = "prototype",
        _c = function c() {
      var t = n(44)("iframe"),
          e = i.length,
          r = "<",
          o = ">",
          a;

      for (t.style.display = "none", n(79).appendChild(t), t.src = "javascript:", a = t.contentWindow.document, a.open(), a.write("<script>document.F=Object<\/script>"), a.close(), _c = a.F; e--;) {
        delete _c[l][i[e]];
      }

      return _c();
    };

    t.exports = Object.create || function t(e, n) {
      var i;
      return null !== e ? (u[l] = r(e), i = new u(), u[l] = null, i[a] = e) : i = _c(), void 0 === n ? i : o(i, n);
    };
  }, function (t, e, n) {
    var r = n(51),
        o = n(31);

    t.exports = Object.keys || function t(e) {
      return r(e, o);
    };
  }, function (t, e) {
    t.exports = "constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf".split(",");
  }, function (t, e, n) {
    var r = n(3).f,
        o = n(5),
        i = n(11)("toStringTag");

    t.exports = function (t, e, n) {
      t && !o(t = n ? t : t.prototype, i) && r(t, i, {
        configurable: !0,
        value: e
      });
    };
  }, function (t, e, n) {
    e.f = n(11);
  }, function (t, e, n) {
    var r = n(0),
        o = n(1),
        i = n(27),
        a = n(33),
        u = n(3).f;

    t.exports = function (t) {
      var e = o.Symbol || (o.Symbol = i ? {} : r.Symbol || {});
      "_" == t.charAt(0) || t in e || u(e, t, {
        value: a.f(t)
      });
    };
  }, function (t, e) {
    e.f = {}.propertyIsEnumerable;
  }, function (t, e, n) {
    var r = n(35),
        o = n(16),
        i = n(6),
        a = n(23),
        u = n(5),
        l = n(43),
        c = Object.getOwnPropertyDescriptor;
    e.f = n(4) ? c : function t(e, n) {
      if (e = i(e), n = a(n, !0), l) try {
        return c(e, n);
      } catch (t) {}
      if (u(e, n)) return o(!r.f.call(e, n), e[n]);
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = n(104),
        i = r(o),
        a = n(7),
        u = r(a),
        l = n(15),
        c = r(l),
        s = n(8),
        f = r(s),
        p = f.default.import("parchment"),
        d = f.default.import("blots/container"),
        h = f.default.import("blots/scroll"),
        b = function () {
      function t() {
        (0, u.default)(this, t);
      }

      return (0, c.default)(t, null, [{
        key: "random_id",
        value: function t() {
          return Math.random().toString(36).slice(2);
        }
      }, {
        key: "find_td",
        value: function t(e) {
          for (var n = e.getLeaf(e.getSelection().index), r = n[0]; null != r && "td" != r.statics.blotName;) {
            r = r.parent;
          }

          return r;
        }
      }, {
        key: "table_handler",
        value: function e(n, r) {
          if (n.includes("newtable_")) {
            for (var o = null, a = n.split("_"), u = (0, i.default)(a[1]), l = (0, i.default)(a[2]), c = t.random_id(), s = p.create("table", c), f = 0; f < u; f++) {
              var b = t.random_id(),
                  v = p.create("tr", b);
              s.appendChild(v);

              for (var g = 0; g < l; g++) {
                n = c + "|" + b + "|" + t.random_id();
                var y = p.create("td", n);
                v.appendChild(y);
                var m = p.create("block");
                y.appendChild(m);

                var _ = p.create("break");

                m.appendChild(_), o = m;
              }
            }

            for (var x = r.getLeaf(r.getSelection().index), A = x[0], w = null; null != A && !(A instanceof d || A instanceof h);) {
              w = A, A = A.parent;
            }

            return A.insertBefore(s, w), o;
          }

          if ("append-col" === n) {
            var k = t.find_td(r);

            if (k) {
              var O = k.parent.parent,
                  j = O.domNode.getAttribute("table_id");
              O.children.forEach(function (e) {
                var n = e.domNode.getAttribute("row_id"),
                    r = t.random_id(),
                    o = p.create("td", j + "|" + n + "|" + r);
                e.appendChild(o);
              });
            }
          } else {
            if ("append-row" !== n) {
              for (var S = t.random_id(), q = p.create("table", S), C = r.getLeaf(r.getSelection().index), N = C[0], M = null; null != N && !(N instanceof d || N instanceof h);) {
                M = N, N = N.parent;
              }

              return N.insertBefore(q, M), q;
            }

            var E = t.find_td(r);

            if (E) {
              var L = E.parent.children.length,
                  T = E.parent.parent,
                  P = E.parent.clone(),
                  B = T.domNode.getAttribute("table_id"),
                  R = t.random_id();
              P.domNode.setAttribute("row_id", R);

              for (var D = L - 1; D >= 0; D--) {
                var U = t.random_id(),
                    I = p.create("td", B + "|" + R + "|" + U);
                P.appendChild(I);
                var F = p.create("block");
                I.appendChild(F);
                var G = p.create("break");
                F.appendChild(G);
              }

              T.appendChild(P), console.log(P);
            }
          }
        }
      }]), t;
    }();

    e.default = b;
  }, function (t, e, n) {
    function r(t) {
      return null === t || void 0 === t;
    }

    function o(t) {
      return !(!t || "object" != _typeof(t) || "number" != typeof t.length) && "function" == typeof t.copy && "function" == typeof t.slice && !(t.length > 0 && "number" != typeof t[0]);
    }

    function i(t, e, n) {
      var i, s;
      if (r(t) || r(e)) return !1;
      if (t.prototype !== e.prototype) return !1;
      if (l(t)) return !!l(e) && (t = a.call(t), e = a.call(e), c(t, e, n));

      if (o(t)) {
        if (!o(e)) return !1;
        if (t.length !== e.length) return !1;

        for (i = 0; i < t.length; i++) {
          if (t[i] !== e[i]) return !1;
        }

        return !0;
      }

      try {
        var f = u(t),
            p = u(e);
      } catch (t) {
        return !1;
      }

      if (f.length != p.length) return !1;

      for (f.sort(), p.sort(), i = f.length - 1; i >= 0; i--) {
        if (f[i] != p[i]) return !1;
      }

      for (i = f.length - 1; i >= 0; i--) {
        if (s = f[i], !c(t[s], e[s], n)) return !1;
      }

      return _typeof(t) == _typeof(e);
    }

    var a = Array.prototype.slice,
        u = n(60),
        l = n(61),
        c = t.exports = function (t, e, n) {
      return n || (n = {}), t === e || (t instanceof Date && e instanceof Date ? t.getTime() === e.getTime() : !t || !e || "object" != _typeof(t) && "object" != _typeof(e) ? n.strict ? t === e : t == e : i(t, e, n));
    };
  }, function (t, e, n) {
    "use strict";

    var r = Object.prototype.hasOwnProperty,
        o = Object.prototype.toString,
        i = function t(e) {
      return "function" == typeof Array.isArray ? Array.isArray(e) : "[object Array]" === o.call(e);
    },
        a = function t(e) {
      if (!e || "[object Object]" !== o.call(e)) return !1;
      var n = r.call(e, "constructor"),
          i = e.constructor && e.constructor.prototype && r.call(e.constructor.prototype, "isPrototypeOf");
      if (e.constructor && !n && !i) return !1;
      var a;

      for (a in e) {
        ;
      }

      return void 0 === a || r.call(e, a);
    };

    t.exports = function t() {
      var e,
          n,
          r,
          o,
          u,
          l,
          c = arguments[0],
          s = 1,
          f = arguments.length,
          p = !1;

      for ("boolean" == typeof c && (p = c, c = arguments[1] || {}, s = 2), (null == c || "object" != _typeof(c) && "function" != typeof c) && (c = {}); s < f; ++s) {
        if (null != (e = arguments[s])) for (n in e) {
          r = c[n], o = e[n], c !== o && (p && o && (a(o) || (u = i(o))) ? (u ? (u = !1, l = r && i(r) ? r : []) : l = r && a(r) ? r : {}, c[n] = t(p, l, o)) : void 0 !== o && (c[n] = o));
        }
      }

      return c;
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = n(63),
        i = r(o),
        a = n(14),
        u = r(a),
        l = n(7),
        c = r(l),
        s = n(15),
        f = r(s),
        p = n(19),
        d = r(p),
        h = n(20),
        b = r(h),
        v = n(21),
        g = r(v),
        y = n(8),
        m = r(y),
        _ = n(22),
        x = r(_),
        A = m.default.import("blots/container"),
        w = m.default.import("blots/block"),
        k = m.default.import("blots/block/embed"),
        O = m.default.import("parchment"),
        j = function (t) {
      function e() {
        return (0, c.default)(this, e), (0, d.default)(this, (e.__proto__ || (0, u.default)(e)).apply(this, arguments));
      }

      return (0, g.default)(e, t), (0, f.default)(e, [{
        key: "format",
        value: function t() {
          this.getAttribute("id");
        }
      }, {
        key: "formats",
        value: function t() {
          return (0, i.default)({}, this.statics.blotName, this.domNode.getAttribute("table_id") + "|" + this.domNode.getAttribute("row_id") + "|" + this.domNode.getAttribute("cell_id"));
        }
      }, {
        key: "optimize",
        value: function t(n) {
          (0, b.default)(e.prototype.__proto__ || (0, u.default)(e.prototype), "optimize", this).call(this, n);
          var r = this.parent;

          if (null != r) {
            if ("td" === r.statics.blotName) return this.moveChildren(r, this), void this.remove();

            if ("tr" != r.statics.blotName) {
              var o = O.create("block");
              this.parent.insertBefore(o, this.next);
              var i = O.create("table", this.domNode.getAttribute("table_id")),
                  a = O.create("tr", this.domNode.getAttribute("row_id"));
              i.appendChild(a), a.appendChild(this), i.replace(o);
            }
          }

          var l = this.next;
          null != l && l.prev === this && l.statics.blotName === this.statics.blotName && l.domNode.tagName === this.domNode.tagName && l.domNode.getAttribute("cell_id") === this.domNode.getAttribute("cell_id") && (l.moveChildren(this), l.remove());
        }
      }, {
        key: "insertBefore",
        value: function t(n, r) {
          if (null != this.statics.allowedChildren && !this.statics.allowedChildren.some(function (t) {
            return n instanceof t;
          })) {
            var o = O.create(this.statics.defaultChild);
            o.appendChild(n), n = o;
          }

          (0, b.default)(e.prototype.__proto__ || (0, u.default)(e.prototype), "insertBefore", this).call(this, n, r);
        }
      }, {
        key: "replace",
        value: function t(n) {
          if (n.statics.blotName !== this.statics.blotName) {
            var r = O.create(this.statics.defaultChild);
            n.moveChildren(r), this.appendChild(r);
          }

          null != n.parent && (0, b.default)(e.prototype.__proto__ || (0, u.default)(e.prototype), "replace", this).call(this, n);
        }
      }, {
        key: "moveChildren",
        value: function t(e, n) {
          this.children.forEach(function (t) {
            e.insertBefore(t, n);
          });
        }
      }, {
        key: "column",
        value: function t() {
          return this.parent.children.offset(this);
        }
      }], [{
        key: "create",
        value: function t(n) {
          var r = "td",
              o = (0, b.default)(e.__proto__ || (0, u.default)(e), "create", this).call(this, "td"),
              i = n.split("|");
          return o.setAttribute("table_id", i[0]), o.setAttribute("row_id", i[1]), o.setAttribute("cell_id", i[2]), o;
        }
      }]), e;
    }(x.default);

    j.blotName = "td", j.tagName = "td", j.scope = O.Scope.BLOCK_BLOT, j.defaultChild = "block", j.allowedChildren = [w, k, A], e.default = j;
  }, function (t, e, n) {
    t.exports = {
      default: n(64),
      __esModule: !0
    };
  }, function (t, e, n) {
    var r = n(66);

    t.exports = function (t, e, n) {
      if (r(t), void 0 === e) return t;

      switch (n) {
        case 1:
          return function (n) {
            return t.call(e, n);
          };

        case 2:
          return function (n, r) {
            return t.call(e, n, r);
          };

        case 3:
          return function (n, r, o) {
            return t.call(e, n, r, o);
          };
      }

      return function () {
        return t.apply(e, arguments);
      };
    };
  }, function (t, e, n) {
    t.exports = !n(4) && !n(10)(function () {
      return 7 != Object.defineProperty(n(44)("div"), "a", {
        get: function get() {
          return 7;
        }
      }).a;
    });
  }, function (t, e, n) {
    var r = n(13),
        o = n(0).document,
        i = r(o) && r(o.createElement);

    t.exports = function (t) {
      return i ? o.createElement(t) : {};
    };
  }, function (t, e, n) {
    var r = n(17);

    t.exports = function (t) {
      return Object(r(t));
    };
  }, function (t, e, n) {
    var r = n(5),
        o = n(45),
        i = n(24)("IE_PROTO"),
        a = Object.prototype;

    t.exports = Object.getPrototypeOf || function (t) {
      return t = o(t), r(t, i) ? t[i] : "function" == typeof t.constructor && t instanceof t.constructor ? t.constructor.prototype : t instanceof Object ? a : null;
    };
  }, function (t, e, n) {
    var r = n(2),
        o = n(1),
        i = n(10);

    t.exports = function (t, e) {
      var n = (o.Object || {})[t] || Object[t],
          a = {};
      a[t] = e(n), r(r.S + r.F * i(function () {
        n(1);
      }), "Object", a);
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.__esModule = !0;
    var o = n(69),
        i = r(o),
        a = n(84),
        u = r(a),
        l = "function" == typeof u.default && "symbol" == _typeof(i.default) ? function (t) {
      return _typeof(t);
    } : function (t) {
      return t && "function" == typeof u.default && t.constructor === u.default && t !== u.default.prototype ? "symbol" : _typeof(t);
    };
    e.default = "function" == typeof u.default && "symbol" === l(i.default) ? function (t) {
      return void 0 === t ? "undefined" : l(t);
    } : function (t) {
      return t && "function" == typeof u.default && t.constructor === u.default && t !== u.default.prototype ? "symbol" : void 0 === t ? "undefined" : l(t);
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(27),
        o = n(2),
        i = n(50),
        a = n(9),
        u = n(5),
        l = n(28),
        c = n(73),
        s = n(32),
        f = n(46),
        p = n(11)("iterator"),
        d = !([].keys && "next" in [].keys()),
        h = "keys",
        b = "values",
        v = function v() {
      return this;
    };

    t.exports = function (t, e, n, g, y, m, _) {
      c(n, e, g);

      var x = function x(t) {
        if (!d && t in O) return O[t];

        switch (t) {
          case h:
            return function e() {
              return new n(this, t);
            };

          case b:
            return function e() {
              return new n(this, t);
            };
        }

        return function e() {
          return new n(this, t);
        };
      },
          A = e + " Iterator",
          w = y == b,
          k = !1,
          O = t.prototype,
          j = O[p] || O["@@iterator"] || y && O[y],
          S = j || x(y),
          q = y ? w ? x("entries") : S : void 0,
          C = "Array" == e ? O.entries || j : j,
          N,
          M,
          E;

      if (C && (E = f(C.call(new t()))) !== Object.prototype && E.next && (s(E, A, !0), r || u(E, p) || a(E, p, v)), w && j && j.name !== b && (k = !0, S = function t() {
        return j.call(this);
      }), r && !_ || !d && !k && O[p] || a(O, p, S), l[e] = S, l[A] = v, y) if (N = {
        values: w ? S : x(b),
        keys: m ? S : x(h),
        entries: q
      }, _) for (M in N) {
        M in O || i(O, M, N[M]);
      } else o(o.P + o.F * (d || k), e, N);
      return N;
    };
  }, function (t, e, n) {
    t.exports = n(9);
  }, function (t, e, n) {
    var r = n(5),
        o = n(6),
        i = n(76)(!1),
        a = n(24)("IE_PROTO");

    t.exports = function (t, e) {
      var n = o(t),
          u = 0,
          l = [],
          c;

      for (c in n) {
        c != a && r(n, c) && l.push(c);
      }

      for (; e.length > u;) {
        r(n, c = e[u++]) && (~i(l, c) || l.push(c));
      }

      return l;
    };
  }, function (t, e) {
    var n = {}.toString;

    t.exports = function (t) {
      return n.call(t).slice(8, -1);
    };
  }, function (t, e) {
    e.f = Object.getOwnPropertySymbols;
  }, function (t, e, n) {
    var r = n(51),
        o = n(31).concat("length", "prototype");

    e.f = Object.getOwnPropertyNames || function t(e) {
      return r(e, o);
    };
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = n(14),
        i = r(o),
        a = n(7),
        u = r(a),
        l = n(15),
        c = r(l),
        s = n(19),
        f = r(s),
        p = n(20),
        d = r(p),
        h = n(21),
        b = r(h),
        v = n(8),
        g = r(v),
        y = n(40),
        m = r(y),
        _ = n(22),
        x = r(_),
        A = n(37),
        w = r(A),
        k = g.default.import("blots/container"),
        O = g.default.import("parchment"),
        j = function (t) {
      function e() {
        return (0, u.default)(this, e), (0, f.default)(this, (e.__proto__ || (0, i.default)(e)).apply(this, arguments));
      }

      return (0, b.default)(e, t), (0, c.default)(e, [{
        key: "format",
        value: function t() {
          this.getAttribute("row_id");
        }
      }, {
        key: "optimize",
        value: function t(e) {
          if (0 === this.children.length) if (null != this.statics.defaultChild) {
            var n = this.createDefaultChild();
            this.appendChild(n), n.optimize(e);
          } else this.remove();
          var r = this.next;
          null != r && r.prev === this && r.statics.blotName === this.statics.blotName && r.domNode.tagName === this.domNode.tagName && r.domNode.getAttribute("row_id") === this.domNode.getAttribute("row_id") && (r.moveChildren(this), r.remove());
        }
      }, {
        key: "insertBefore",
        value: function t(n, r) {
          if (null != this.statics.allowedChildren && !this.statics.allowedChildren.some(function (t) {
            return n instanceof t;
          })) {
            var o = this.createDefaultChild(r);
            o.appendChild(n), n = o;
          }

          (0, d.default)(e.prototype.__proto__ || (0, i.default)(e.prototype), "insertBefore", this).call(this, n, r);
        }
      }, {
        key: "replace",
        value: function t(n) {
          if (n.statics.blotName !== this.statics.blotName) {
            var r = this.createDefaultChild();
            n.moveChildren(r, this), this.appendChild(r);
          }

          (0, d.default)(e.prototype.__proto__ || (0, i.default)(e.prototype), "replace", this).call(this, n);
        }
      }, {
        key: "createDefaultChild",
        value: function t(e) {
          var n = null;
          return n = e ? e.domNode.getAttribute("table_id") : this.parent ? this.parent.domNode.getAttribute("table_id") : this.domNode.parent.getAttribute("table_id"), O.create(this.statics.defaultChild, [n, this.domNode.getAttribute("row_id"), w.default.random_id()].join("|"));
        }
      }], [{
        key: "create",
        value: function t(n) {
          var r = "tr",
              o = (0, d.default)(e.__proto__ || (0, i.default)(e), "create", this).call(this, "tr");
          return o.setAttribute("row_id", n || w.default.random_id()), o;
        }
      }]), e;
    }(x.default);

    j.blotName = "tr", j.tagName = "tr", j.scope = O.Scope.BLOCK_BLOT, j.defaultChild = "td", j.allowedChildren = [m.default], e.default = j;
  }, function (t, e) {
    t.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    var o = n(7),
        i = r(o),
        a = n(8),
        u = r(a),
        l = n(58),
        c = r(l),
        s = n(40),
        f = r(s),
        p = n(55),
        d = r(p),
        h = n(109),
        b = r(h),
        v = n(22),
        g = r(v);
    n(110);
    var y = n(37),
        m = r(y);
    u.default.import("blots/container").order = ["list", "contain", "td", "tr", "table"];

    var _ = function t(e, n) {
      (0, i.default)(this, t), e.getModule("toolbar").addHandler("table", function (t) {
        return m.default.table_handler(t, e);
      });
      var r = e.getModule("clipboard");
      r.addMatcher("TABLE", function (t, e) {
        return e;
      }), r.addMatcher("TR", function (t, e) {
        return e;
      }), r.addMatcher("TD", function (t, e) {
        return e.compose(new c.default().retain(e.length(), {
          td: t.getAttribute("table_id") + "|" + t.getAttribute("row_id") + "|" + t.getAttribute("cell_id")
        }));
      });
    };

    t.exports = {
      Table: b.default,
      TableRow: d.default,
      TableCell: f.default,
      Contain: g.default,
      TableModule: _
    };
  }, function (t, e, n) {
    var r = n(59),
        o = n(38),
        i = n(39),
        a = n(62),
        u = String.fromCharCode(0),
        l = function l(t) {
      Array.isArray(t) ? this.ops = t : null != t && Array.isArray(t.ops) ? this.ops = t.ops : this.ops = [];
    };

    l.prototype.insert = function (t, e) {
      var n = {};
      return 0 === t.length ? this : (n.insert = t, null != e && "object" == _typeof(e) && Object.keys(e).length > 0 && (n.attributes = e), this.push(n));
    }, l.prototype.delete = function (t) {
      return t <= 0 ? this : this.push({
        delete: t
      });
    }, l.prototype.retain = function (t, e) {
      if (t <= 0) return this;
      var n = {
        retain: t
      };
      return null != e && "object" == _typeof(e) && Object.keys(e).length > 0 && (n.attributes = e), this.push(n);
    }, l.prototype.push = function (t) {
      var e = this.ops.length,
          n = this.ops[e - 1];

      if (t = i(!0, {}, t), "object" == _typeof(n)) {
        if ("number" == typeof t.delete && "number" == typeof n.delete) return this.ops[e - 1] = {
          delete: n.delete + t.delete
        }, this;
        if ("number" == typeof n.delete && null != t.insert && (e -= 1, "object" != _typeof(n = this.ops[e - 1]))) return this.ops.unshift(t), this;

        if (o(t.attributes, n.attributes)) {
          if ("string" == typeof t.insert && "string" == typeof n.insert) return this.ops[e - 1] = {
            insert: n.insert + t.insert
          }, "object" == _typeof(t.attributes) && (this.ops[e - 1].attributes = t.attributes), this;
          if ("number" == typeof t.retain && "number" == typeof n.retain) return this.ops[e - 1] = {
            retain: n.retain + t.retain
          }, "object" == _typeof(t.attributes) && (this.ops[e - 1].attributes = t.attributes), this;
        }
      }

      return e === this.ops.length ? this.ops.push(t) : this.ops.splice(e, 0, t), this;
    }, l.prototype.chop = function () {
      var t = this.ops[this.ops.length - 1];
      return t && t.retain && !t.attributes && this.ops.pop(), this;
    }, l.prototype.filter = function (t) {
      return this.ops.filter(t);
    }, l.prototype.forEach = function (t) {
      this.ops.forEach(t);
    }, l.prototype.map = function (t) {
      return this.ops.map(t);
    }, l.prototype.partition = function (t) {
      var e = [],
          n = [];
      return this.forEach(function (r) {
        (t(r) ? e : n).push(r);
      }), [e, n];
    }, l.prototype.reduce = function (t, e) {
      return this.ops.reduce(t, e);
    }, l.prototype.changeLength = function () {
      return this.reduce(function (t, e) {
        return e.insert ? t + a.length(e) : e.delete ? t - e.delete : t;
      }, 0);
    }, l.prototype.length = function () {
      return this.reduce(function (t, e) {
        return t + a.length(e);
      }, 0);
    }, l.prototype.slice = function (t, e) {
      t = t || 0, "number" != typeof e && (e = 1 / 0);

      for (var n = [], r = a.iterator(this.ops), o = 0; o < e && r.hasNext();) {
        var i;
        o < t ? i = r.next(t - o) : (i = r.next(e - o), n.push(i)), o += a.length(i);
      }

      return new l(n);
    }, l.prototype.compose = function (t) {
      for (var e = a.iterator(this.ops), n = a.iterator(t.ops), r = new l(); e.hasNext() || n.hasNext();) {
        if ("insert" === n.peekType()) r.push(n.next());else if ("delete" === e.peekType()) r.push(e.next());else {
          var o = Math.min(e.peekLength(), n.peekLength()),
              i = e.next(o),
              u = n.next(o);

          if ("number" == typeof u.retain) {
            var c = {};
            "number" == typeof i.retain ? c.retain = o : c.insert = i.insert;
            var s = a.attributes.compose(i.attributes, u.attributes, "number" == typeof i.retain);
            s && (c.attributes = s), r.push(c);
          } else "number" == typeof u.delete && "number" == typeof i.retain && r.push(u);
        }
      }

      return r.chop();
    }, l.prototype.concat = function (t) {
      var e = new l(this.ops.slice());
      return t.ops.length > 0 && (e.push(t.ops[0]), e.ops = e.ops.concat(t.ops.slice(1))), e;
    }, l.prototype.diff = function (t, e) {
      if (this.ops === t.ops) return new l();
      var n = [this, t].map(function (e) {
        return e.map(function (n) {
          if (null != n.insert) return "string" == typeof n.insert ? n.insert : u;
          var r = e === t ? "on" : "with";
          throw new Error("diff() called " + r + " non-document");
        }).join("");
      }),
          i = new l(),
          c = r(n[0], n[1], e),
          s = a.iterator(this.ops),
          f = a.iterator(t.ops);
      return c.forEach(function (t) {
        for (var e = t[1].length; e > 0;) {
          var n = 0;

          switch (t[0]) {
            case r.INSERT:
              n = Math.min(f.peekLength(), e), i.push(f.next(n));
              break;

            case r.DELETE:
              n = Math.min(e, s.peekLength()), s.next(n), i.delete(n);
              break;

            case r.EQUAL:
              n = Math.min(s.peekLength(), f.peekLength(), e);
              var u = s.next(n),
                  l = f.next(n);
              o(u.insert, l.insert) ? i.retain(n, a.attributes.diff(u.attributes, l.attributes)) : i.push(l).delete(n);
          }

          e -= n;
        }
      }), i.chop();
    }, l.prototype.eachLine = function (t, e) {
      e = e || "\n";

      for (var n = a.iterator(this.ops), r = new l(), o = 0; n.hasNext();) {
        if ("insert" !== n.peekType()) return;
        var i = n.peek(),
            u = a.length(i) - n.peekLength(),
            c = "string" == typeof i.insert ? i.insert.indexOf(e, u) - u : -1;
        if (c < 0) r.push(n.next());else if (c > 0) r.push(n.next(c));else {
          if (!1 === t(r, n.next(1).attributes || {}, o)) return;
          o += 1, r = new l();
        }
      }

      r.length() > 0 && t(r, {}, o);
    }, l.prototype.transform = function (t, e) {
      if (e = !!e, "number" == typeof t) return this.transformPosition(t, e);

      for (var n = a.iterator(this.ops), r = a.iterator(t.ops), o = new l(); n.hasNext() || r.hasNext();) {
        if ("insert" !== n.peekType() || !e && "insert" === r.peekType()) {
          if ("insert" === r.peekType()) o.push(r.next());else {
            var i = Math.min(n.peekLength(), r.peekLength()),
                u = n.next(i),
                c = r.next(i);
            if (u.delete) continue;
            c.delete ? o.push(c) : o.retain(i, a.attributes.transform(u.attributes, c.attributes, e));
          }
        } else o.retain(a.length(n.next()));
      }

      return o.chop();
    }, l.prototype.transformPosition = function (t, e) {
      e = !!e;

      for (var n = a.iterator(this.ops), r = 0; n.hasNext() && r <= t;) {
        var o = n.peekLength(),
            i = n.peekType();
        n.next(), "delete" !== i ? ("insert" === i && (r < t || !e) && (t += o), r += o) : t -= Math.min(o, t - r);
      }

      return t;
    }, t.exports = l;
  }, function (t, e) {
    function n(t, e, n) {
      if (t == e) return t ? [[v, t]] : [];
      (n < 0 || t.length < n) && (n = null);
      var o = a(t, e),
          i = t.substring(0, o);
      t = t.substring(o), e = e.substring(o), o = u(t, e);
      var l = t.substring(t.length - o);
      t = t.substring(0, t.length - o), e = e.substring(0, e.length - o);
      var s = r(t, e);
      return i && s.unshift([v, i]), l && s.push([v, l]), c(s), null != n && (s = f(s, n)), s = p(s);
    }

    function r(t, e) {
      var r;
      if (!t) return [[b, e]];
      if (!e) return [[h, t]];
      var i = t.length > e.length ? t : e,
          a = t.length > e.length ? e : t,
          u = i.indexOf(a);
      if (-1 != u) return r = [[b, i.substring(0, u)], [v, a], [b, i.substring(u + a.length)]], t.length > e.length && (r[0][0] = r[2][0] = h), r;
      if (1 == a.length) return [[h, t], [b, e]];
      var c = l(t, e);

      if (c) {
        var s = c[0],
            f = c[1],
            p = c[2],
            d = c[3],
            g = c[4],
            y = n(s, p),
            m = n(f, d);
        return y.concat([[v, g]], m);
      }

      return o(t, e);
    }

    function o(t, e) {
      for (var n = t.length, r = e.length, o = Math.ceil((n + r) / 2), a = o, u = 2 * o, l = new Array(u), c = new Array(u), s = 0; s < u; s++) {
        l[s] = -1, c[s] = -1;
      }

      l[a + 1] = 0, c[a + 1] = 0;

      for (var f = n - r, p = f % 2 != 0, d = 0, v = 0, g = 0, y = 0, m = 0; m < o; m++) {
        for (var _ = -m + d; _ <= m - v; _ += 2) {
          var x = a + _,
              A;
          A = _ == -m || _ != m && l[x - 1] < l[x + 1] ? l[x + 1] : l[x - 1] + 1;

          for (var w = A - _; A < n && w < r && t.charAt(A) == e.charAt(w);) {
            A++, w++;
          }

          if (l[x] = A, A > n) v += 2;else if (w > r) d += 2;else if (p) {
            var k = a + f - _;

            if (k >= 0 && k < u && -1 != c[k]) {
              var O = n - c[k];
              if (A >= O) return i(t, e, A, w);
            }
          }
        }

        for (var j = -m + g; j <= m - y; j += 2) {
          var k = a + j,
              O;
          O = j == -m || j != m && c[k - 1] < c[k + 1] ? c[k + 1] : c[k - 1] + 1;

          for (var S = O - j; O < n && S < r && t.charAt(n - O - 1) == e.charAt(r - S - 1);) {
            O++, S++;
          }

          if (c[k] = O, O > n) y += 2;else if (S > r) g += 2;else if (!p) {
            var x = a + f - j;

            if (x >= 0 && x < u && -1 != l[x]) {
              var A = l[x],
                  w = a + A - x;
              if (O = n - O, A >= O) return i(t, e, A, w);
            }
          }
        }
      }

      return [[h, t], [b, e]];
    }

    function i(t, e, r, o) {
      var i = t.substring(0, r),
          a = e.substring(0, o),
          u = t.substring(r),
          l = e.substring(o),
          c = n(i, a),
          s = n(u, l);
      return c.concat(s);
    }

    function a(t, e) {
      if (!t || !e || t.charAt(0) != e.charAt(0)) return 0;

      for (var n = 0, r = Math.min(t.length, e.length), o = r, i = 0; n < o;) {
        t.substring(i, o) == e.substring(i, o) ? (n = o, i = n) : r = o, o = Math.floor((r - n) / 2 + n);
      }

      return o;
    }

    function u(t, e) {
      if (!t || !e || t.charAt(t.length - 1) != e.charAt(e.length - 1)) return 0;

      for (var n = 0, r = Math.min(t.length, e.length), o = r, i = 0; n < o;) {
        t.substring(t.length - o, t.length - i) == e.substring(e.length - o, e.length - i) ? (n = o, i = n) : r = o, o = Math.floor((r - n) / 2 + n);
      }

      return o;
    }

    function l(t, e) {
      function n(t, e, n) {
        for (var r = t.substring(n, n + Math.floor(t.length / 4)), o = -1, i = "", l, c, s, f; -1 != (o = e.indexOf(r, o + 1));) {
          var p = a(t.substring(n), e.substring(o)),
              d = u(t.substring(0, n), e.substring(0, o));
          i.length < d + p && (i = e.substring(o - d, o) + e.substring(o, o + p), l = t.substring(0, n - d), c = t.substring(n + p), s = e.substring(0, o - d), f = e.substring(o + p));
        }

        return 2 * i.length >= t.length ? [l, c, s, f, i] : null;
      }

      var r = t.length > e.length ? t : e,
          o = t.length > e.length ? e : t;
      if (r.length < 4 || 2 * o.length < r.length) return null;
      var i = n(r, o, Math.ceil(r.length / 4)),
          l = n(r, o, Math.ceil(r.length / 2)),
          c;
      if (!i && !l) return null;
      c = l ? i && i[4].length > l[4].length ? i : l : i;
      var s, f, p, d;
      return t.length > e.length ? (s = c[0], f = c[1], p = c[2], d = c[3]) : (p = c[0], d = c[1], s = c[2], f = c[3]), [s, f, p, d, c[4]];
    }

    function c(t) {
      t.push([v, ""]);

      for (var e = 0, n = 0, r = 0, o = "", i = "", l; e < t.length;) {
        switch (t[e][0]) {
          case b:
            r++, i += t[e][1], e++;
            break;

          case h:
            n++, o += t[e][1], e++;
            break;

          case v:
            n + r > 1 ? (0 !== n && 0 !== r && (l = a(i, o), 0 !== l && (e - n - r > 0 && t[e - n - r - 1][0] == v ? t[e - n - r - 1][1] += i.substring(0, l) : (t.splice(0, 0, [v, i.substring(0, l)]), e++), i = i.substring(l), o = o.substring(l)), 0 !== (l = u(i, o)) && (t[e][1] = i.substring(i.length - l) + t[e][1], i = i.substring(0, i.length - l), o = o.substring(0, o.length - l))), 0 === n ? t.splice(e - r, n + r, [b, i]) : 0 === r ? t.splice(e - n, n + r, [h, o]) : t.splice(e - n - r, n + r, [h, o], [b, i]), e = e - n - r + (n ? 1 : 0) + (r ? 1 : 0) + 1) : 0 !== e && t[e - 1][0] == v ? (t[e - 1][1] += t[e][1], t.splice(e, 1)) : e++, r = 0, n = 0, o = "", i = "";
        }
      }

      "" === t[t.length - 1][1] && t.pop();
      var s = !1;

      for (e = 1; e < t.length - 1;) {
        t[e - 1][0] == v && t[e + 1][0] == v && (t[e][1].substring(t[e][1].length - t[e - 1][1].length) == t[e - 1][1] ? (t[e][1] = t[e - 1][1] + t[e][1].substring(0, t[e][1].length - t[e - 1][1].length), t[e + 1][1] = t[e - 1][1] + t[e + 1][1], t.splice(e - 1, 1), s = !0) : t[e][1].substring(0, t[e + 1][1].length) == t[e + 1][1] && (t[e - 1][1] += t[e + 1][1], t[e][1] = t[e][1].substring(t[e + 1][1].length) + t[e + 1][1], t.splice(e + 1, 1), s = !0)), e++;
      }

      s && c(t);
    }

    function s(t, e) {
      if (0 === e) return [v, t];

      for (var n = 0, r = 0; r < t.length; r++) {
        var o = t[r];

        if (o[0] === h || o[0] === v) {
          var i = n + o[1].length;
          if (e === i) return [r + 1, t];

          if (e < i) {
            t = t.slice();
            var a = e - n,
                u = [o[0], o[1].slice(0, a)],
                l = [o[0], o[1].slice(a)];
            return t.splice(r, 1, u, l), [r + 1, t];
          }

          n = i;
        }
      }

      throw new Error("cursor_pos is out of bounds!");
    }

    function f(t, e) {
      var n = s(t, e),
          r = n[1],
          o = n[0],
          i = r[o],
          a = r[o + 1];
      if (null == i) return t;
      if (i[0] !== v) return t;
      if (null != a && i[1] + a[1] === a[1] + i[1]) return r.splice(o, 2, a, i), d(r, o, 2);

      if (null != a && 0 === a[1].indexOf(i[1])) {
        r.splice(o, 2, [a[0], i[1]], [0, i[1]]);
        var u = a[1].slice(i[1].length);
        return u.length > 0 && r.splice(o + 2, 0, [a[0], u]), d(r, o, 3);
      }

      return t;
    }

    function p(t) {
      for (var e = !1, n = function n(t) {
        return t.charCodeAt(0) >= 56320 && t.charCodeAt(0) <= 57343;
      }, r = function r(t) {
        return t.charCodeAt(t.length - 1) >= 55296 && t.charCodeAt(t.length - 1) <= 56319;
      }, o = 2; o < t.length; o += 1) {
        t[o - 2][0] === v && r(t[o - 2][1]) && t[o - 1][0] === h && n(t[o - 1][1]) && t[o][0] === b && n(t[o][1]) && (e = !0, t[o - 1][1] = t[o - 2][1].slice(-1) + t[o - 1][1], t[o][1] = t[o - 2][1].slice(-1) + t[o][1], t[o - 2][1] = t[o - 2][1].slice(0, -1));
      }

      if (!e) return t;

      for (var i = [], o = 0; o < t.length; o += 1) {
        t[o][1].length > 0 && i.push(t[o]);
      }

      return i;
    }

    function d(t, e, n) {
      for (var r = e + n - 1; r >= 0 && r >= e - 1; r--) {
        if (r + 1 < t.length) {
          var o = t[r],
              i = t[r + 1];
          o[0] === i[1] && t.splice(r, 2, [o[0], o[1] + i[1]]);
        }
      }

      return t;
    }

    var h = -1,
        b = 1,
        v = 0,
        g = n;
    g.INSERT = b, g.DELETE = h, g.EQUAL = v, t.exports = g;
  }, function (t, e) {
    function n(t) {
      var e = [];

      for (var n in t) {
        e.push(n);
      }

      return e;
    }

    e = t.exports = "function" == typeof Object.keys ? Object.keys : n, e.shim = n;
  }, function (t, e) {
    function n(t) {
      return "[object Arguments]" == Object.prototype.toString.call(t);
    }

    function r(t) {
      return t && "object" == _typeof(t) && "number" == typeof t.length && Object.prototype.hasOwnProperty.call(t, "callee") && !Object.prototype.propertyIsEnumerable.call(t, "callee") || !1;
    }

    var o = "[object Arguments]" == function () {
      return Object.prototype.toString.call(arguments);
    }();

    e = t.exports = o ? n : r, e.supported = n, e.unsupported = r;
  }, function (t, e, n) {
    function r(t) {
      this.ops = t, this.index = 0, this.offset = 0;
    }

    var o = n(38),
        i = n(39),
        a = {
      attributes: {
        compose: function compose(t, e, n) {
          "object" != _typeof(t) && (t = {}), "object" != _typeof(e) && (e = {});
          var r = i(!0, {}, e);
          n || (r = Object.keys(r).reduce(function (t, e) {
            return null != r[e] && (t[e] = r[e]), t;
          }, {}));

          for (var o in t) {
            void 0 !== t[o] && void 0 === e[o] && (r[o] = t[o]);
          }

          return Object.keys(r).length > 0 ? r : void 0;
        },
        diff: function diff(t, e) {
          "object" != _typeof(t) && (t = {}), "object" != _typeof(e) && (e = {});
          var n = Object.keys(t).concat(Object.keys(e)).reduce(function (n, r) {
            return o(t[r], e[r]) || (n[r] = void 0 === e[r] ? null : e[r]), n;
          }, {});
          return Object.keys(n).length > 0 ? n : void 0;
        },
        transform: function transform(t, e, n) {
          if ("object" != _typeof(t)) return e;

          if ("object" == _typeof(e)) {
            if (!n) return e;
            var r = Object.keys(e).reduce(function (n, r) {
              return void 0 === t[r] && (n[r] = e[r]), n;
            }, {});
            return Object.keys(r).length > 0 ? r : void 0;
          }
        }
      },
      iterator: function iterator(t) {
        return new r(t);
      },
      length: function length(t) {
        return "number" == typeof t.delete ? t.delete : "number" == typeof t.retain ? t.retain : "string" == typeof t.insert ? t.insert.length : 1;
      }
    };
    r.prototype.hasNext = function () {
      return this.peekLength() < 1 / 0;
    }, r.prototype.next = function (t) {
      t || (t = 1 / 0);
      var e = this.ops[this.index];

      if (e) {
        var n = this.offset,
            r = a.length(e);
        if (t >= r - n ? (t = r - n, this.index += 1, this.offset = 0) : this.offset += t, "number" == typeof e.delete) return {
          delete: t
        };
        var o = {};
        return e.attributes && (o.attributes = e.attributes), "number" == typeof e.retain ? o.retain = t : "string" == typeof e.insert ? o.insert = e.insert.substr(n, t) : o.insert = e.insert, o;
      }

      return {
        retain: 1 / 0
      };
    }, r.prototype.peek = function () {
      return this.ops[this.index];
    }, r.prototype.peekLength = function () {
      return this.ops[this.index] ? a.length(this.ops[this.index]) - this.offset : 1 / 0;
    }, r.prototype.peekType = function () {
      return this.ops[this.index] ? "number" == typeof this.ops[this.index].delete ? "delete" : "number" == typeof this.ops[this.index].retain ? "retain" : "insert" : "retain";
    }, t.exports = a;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    e.__esModule = !0;
    var o = n(41),
        i = r(o);

    e.default = function (t, e, n) {
      return e in t ? (0, i.default)(t, e, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : t[e] = n, t;
    };
  }, function (t, e, n) {
    n(65);
    var r = n(1).Object;

    t.exports = function t(e, n, o) {
      return r.defineProperty(e, n, o);
    };
  }, function (t, e, n) {
    var r = n(2);
    r(r.S + r.F * !n(4), "Object", {
      defineProperty: n(3).f
    });
  }, function (t, e) {
    t.exports = function (t) {
      if ("function" != typeof t) throw TypeError(t + " is not a function!");
      return t;
    };
  }, function (t, e, n) {
    n(68), t.exports = n(1).Object.getPrototypeOf;
  }, function (t, e, n) {
    var r = n(45),
        o = n(46);
    n(47)("getPrototypeOf", function () {
      return function t(e) {
        return o(r(e));
      };
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(70),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(71), n(80), t.exports = n(33).f("iterator");
  }, function (t, e, n) {
    "use strict";

    var r = n(72)(!0);
    n(49)(String, "String", function (t) {
      this._t = String(t), this._i = 0;
    }, function () {
      var t = this._t,
          e = this._i,
          n;
      return e >= t.length ? {
        value: void 0,
        done: !0
      } : (n = r(t, e), this._i += n.length, {
        value: n,
        done: !1
      });
    });
  }, function (t, e, n) {
    var r = n(26),
        o = n(17);

    t.exports = function (t) {
      return function (e, n) {
        var i = String(o(e)),
            a = r(n),
            u = i.length,
            l,
            c;
        return a < 0 || a >= u ? t ? "" : void 0 : (l = i.charCodeAt(a), l < 55296 || l > 56319 || a + 1 === u || (c = i.charCodeAt(a + 1)) < 56320 || c > 57343 ? t ? i.charAt(a) : l : t ? i.slice(a, a + 2) : c - 56320 + (l - 55296 << 10) + 65536);
      };
    };
  }, function (t, e, n) {
    "use strict";

    var r = n(29),
        o = n(16),
        i = n(32),
        a = {};
    n(9)(a, n(11)("iterator"), function () {
      return this;
    }), t.exports = function (t, e, n) {
      t.prototype = r(a, {
        next: o(1, n)
      }), i(t, e + " Iterator");
    };
  }, function (t, e, n) {
    var r = n(3),
        o = n(12),
        i = n(30);
    t.exports = n(4) ? Object.defineProperties : function t(e, n) {
      o(e);

      for (var a = i(n), u = a.length, l = 0, c; u > l;) {
        r.f(e, c = a[l++], n[c]);
      }

      return e;
    };
  }, function (t, e, n) {
    var r = n(52);
    t.exports = Object("z").propertyIsEnumerable(0) ? Object : function (t) {
      return "String" == r(t) ? t.split("") : Object(t);
    };
  }, function (t, e, n) {
    var r = n(6),
        o = n(77),
        i = n(78);

    t.exports = function (t) {
      return function (e, n, a) {
        var u = r(e),
            l = o(u.length),
            c = i(a, l),
            s;

        if (t && n != n) {
          for (; l > c;) {
            if ((s = u[c++]) != s) return !0;
          }
        } else for (; l > c; c++) {
          if ((t || c in u) && u[c] === n) return t || c || 0;
        }

        return !t && -1;
      };
    };
  }, function (t, e, n) {
    var r = n(26),
        o = Math.min;

    t.exports = function (t) {
      return t > 0 ? o(r(t), 9007199254740991) : 0;
    };
  }, function (t, e, n) {
    var r = n(26),
        o = Math.max,
        i = Math.min;

    t.exports = function (t, e) {
      return t = r(t), t < 0 ? o(t + e, 0) : i(t, e);
    };
  }, function (t, e, n) {
    var r = n(0).document;
    t.exports = r && r.documentElement;
  }, function (t, e, n) {
    n(81);

    for (var r = n(0), o = n(9), i = n(28), a = n(11)("toStringTag"), u = "CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,TextTrackList,TouchList".split(","), l = 0; l < u.length; l++) {
      var c = u[l],
          s = r[c],
          f = s && s.prototype;
      f && !f[a] && o(f, a, c), i[c] = i.Array;
    }
  }, function (t, e, n) {
    "use strict";

    var r = n(82),
        o = n(83),
        i = n(28),
        a = n(6);
    t.exports = n(49)(Array, "Array", function (t, e) {
      this._t = a(t), this._i = 0, this._k = e;
    }, function () {
      var t = this._t,
          e = this._k,
          n = this._i++;
      return !t || n >= t.length ? (this._t = void 0, o(1)) : "keys" == e ? o(0, n) : "values" == e ? o(0, t[n]) : o(0, [n, t[n]]);
    }, "values"), i.Arguments = i.Array, r("keys"), r("values"), r("entries");
  }, function (t, e) {
    t.exports = function () {};
  }, function (t, e) {
    t.exports = function (t, e) {
      return {
        value: e,
        done: !!t
      };
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(85),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(86), n(91), n(92), n(93), t.exports = n(1).Symbol;
  }, function (t, e, n) {
    "use strict";

    var r = n(0),
        o = n(5),
        i = n(4),
        a = n(2),
        u = n(50),
        l = n(87).KEY,
        c = n(10),
        s = n(25),
        f = n(32),
        p = n(18),
        d = n(11),
        h = n(33),
        b = n(34),
        v = n(88),
        g = n(89),
        y = n(12),
        m = n(6),
        _ = n(23),
        x = n(16),
        A = n(29),
        w = n(90),
        k = n(36),
        O = n(3),
        j = n(30),
        S = k.f,
        q = O.f,
        C = w.f,
        N = r.Symbol,
        M = r.JSON,
        E = M && M.stringify,
        L = "prototype",
        T = d("_hidden"),
        P = d("toPrimitive"),
        B = {}.propertyIsEnumerable,
        R = s("symbol-registry"),
        D = s("symbols"),
        U = s("op-symbols"),
        I = Object[L],
        F = "function" == typeof N,
        G = r.QObject,
        Q = !G || !G[L] || !G[L].findChild,
        z = i && c(function () {
      return 7 != A(q({}, "a", {
        get: function get() {
          return q(this, "a", {
            value: 7
          }).a;
        }
      })).a;
    }) ? function (t, e, n) {
      var r = S(I, e);
      r && delete I[e], q(t, e, n), r && t !== I && q(I, e, r);
    } : q,
        J = function J(t) {
      var e = D[t] = A(N[L]);
      return e._k = t, e;
    },
        H = F && "symbol" == _typeof(N.iterator) ? function (t) {
      return "symbol" == _typeof(t);
    } : function (t) {
      return t instanceof N;
    },
        V = function t(e, n, r) {
      return e === I && V(U, n, r), y(e), n = _(n, !0), y(r), o(D, n) ? (r.enumerable ? (o(e, T) && e[T][n] && (e[T][n] = !1), r = A(r, {
        enumerable: x(0, !1)
      })) : (o(e, T) || q(e, T, x(1, {})), e[T][n] = !0), z(e, n, r)) : q(e, n, r);
    },
        Y = function t(e, n) {
      y(e);

      for (var r = v(n = m(n)), o = 0, i = r.length, a; i > o;) {
        V(e, a = r[o++], n[a]);
      }

      return e;
    },
        K = function t(e, n) {
      return void 0 === n ? A(e) : Y(A(e), n);
    },
        Z = function t(e) {
      var n = B.call(this, e = _(e, !0));
      return !(this === I && o(D, e) && !o(U, e)) && (!(n || !o(this, e) || !o(D, e) || o(this, T) && this[T][e]) || n);
    },
        W = function t(e, n) {
      if (e = m(e), n = _(n, !0), e !== I || !o(D, n) || o(U, n)) {
        var r = S(e, n);
        return !r || !o(D, n) || o(e, T) && e[T][n] || (r.enumerable = !0), r;
      }
    },
        X = function t(e) {
      for (var n = C(m(e)), r = [], i = 0, a; n.length > i;) {
        o(D, a = n[i++]) || a == T || a == l || r.push(a);
      }

      return r;
    },
        $ = function t(e) {
      for (var n = e === I, r = C(n ? U : m(e)), i = [], a = 0, u; r.length > a;) {
        !o(D, u = r[a++]) || n && !o(I, u) || i.push(D[u]);
      }

      return i;
    };

    F || (N = function t() {
      if (this instanceof N) throw TypeError("Symbol is not a constructor!");

      var e = p(arguments.length > 0 ? arguments[0] : void 0),
          n = function n(t) {
        this === I && n.call(U, t), o(this, T) && o(this[T], e) && (this[T][e] = !1), z(this, e, x(1, t));
      };

      return i && Q && z(I, e, {
        configurable: !0,
        set: n
      }), J(e);
    }, u(N[L], "toString", function t() {
      return this._k;
    }), k.f = W, O.f = V, n(54).f = w.f = X, n(35).f = Z, n(53).f = $, i && !n(27) && u(I, "propertyIsEnumerable", Z, !0), h.f = function (t) {
      return J(d(t));
    }), a(a.G + a.W + a.F * !F, {
      Symbol: N
    });

    for (var tt = "hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables".split(","), et = 0; tt.length > et;) {
      d(tt[et++]);
    }

    for (var nt = j(d.store), rt = 0; nt.length > rt;) {
      b(nt[rt++]);
    }

    a(a.S + a.F * !F, "Symbol", {
      for: function _for(t) {
        return o(R, t += "") ? R[t] : R[t] = N(t);
      },
      keyFor: function t(e) {
        if (!H(e)) throw TypeError(e + " is not a symbol!");

        for (var n in R) {
          if (R[n] === e) return n;
        }
      },
      useSetter: function useSetter() {
        Q = !0;
      },
      useSimple: function useSimple() {
        Q = !1;
      }
    }), a(a.S + a.F * !F, "Object", {
      create: K,
      defineProperty: V,
      defineProperties: Y,
      getOwnPropertyDescriptor: W,
      getOwnPropertyNames: X,
      getOwnPropertySymbols: $
    }), M && a(a.S + a.F * (!F || c(function () {
      var t = N();
      return "[null]" != E([t]) || "{}" != E({
        a: t
      }) || "{}" != E(Object(t));
    })), "JSON", {
      stringify: function t(e) {
        if (void 0 !== e && !H(e)) {
          for (var n = [e], r = 1, o, i; arguments.length > r;) {
            n.push(arguments[r++]);
          }

          return o = n[1], "function" == typeof o && (i = o), !i && g(o) || (o = function o(t, e) {
            if (i && (e = i.call(this, t, e)), !H(e)) return e;
          }), n[1] = o, E.apply(M, n);
        }
      }
    }), N[L][P] || n(9)(N[L], P, N[L].valueOf), f(N, "Symbol"), f(Math, "Math", !0), f(r.JSON, "JSON", !0);
  }, function (t, e, n) {
    var r = n(18)("meta"),
        o = n(13),
        i = n(5),
        a = n(3).f,
        u = 0,
        l = Object.isExtensible || function () {
      return !0;
    },
        c = !n(10)(function () {
      return l(Object.preventExtensions({}));
    }),
        s = function s(t) {
      a(t, r, {
        value: {
          i: "O" + ++u,
          w: {}
        }
      });
    },
        f = function f(t, e) {
      if (!o(t)) return "symbol" == _typeof(t) ? t : ("string" == typeof t ? "S" : "P") + t;

      if (!i(t, r)) {
        if (!l(t)) return "F";
        if (!e) return "E";
        s(t);
      }

      return t[r].i;
    },
        p = function p(t, e) {
      if (!i(t, r)) {
        if (!l(t)) return !0;
        if (!e) return !1;
        s(t);
      }

      return t[r].w;
    },
        d = function d(t) {
      return c && h.NEED && l(t) && !i(t, r) && s(t), t;
    },
        h = t.exports = {
      KEY: r,
      NEED: !1,
      fastKey: f,
      getWeak: p,
      onFreeze: d
    };
  }, function (t, e, n) {
    var r = n(30),
        o = n(53),
        i = n(35);

    t.exports = function (t) {
      var e = r(t),
          n = o.f;
      if (n) for (var a = n(t), u = i.f, l = 0, c; a.length > l;) {
        u.call(t, c = a[l++]) && e.push(c);
      }
      return e;
    };
  }, function (t, e, n) {
    var r = n(52);

    t.exports = Array.isArray || function t(e) {
      return "Array" == r(e);
    };
  }, function (t, e, n) {
    var r = n(6),
        o = n(54).f,
        i = {}.toString,
        a = "object" == (typeof window === "undefined" ? "undefined" : _typeof(window)) && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [],
        u = function u(t) {
      try {
        return o(t);
      } catch (t) {
        return a.slice();
      }
    };

    t.exports.f = function t(e) {
      return a && "[object Window]" == i.call(e) ? u(e) : o(r(e));
    };
  }, function (t, e) {}, function (t, e, n) {
    n(34)("asyncIterator");
  }, function (t, e, n) {
    n(34)("observable");
  }, function (t, e, n) {
    t.exports = {
      default: n(95),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(96);
    var r = n(1).Object;

    t.exports = function t(e, n) {
      return r.getOwnPropertyDescriptor(e, n);
    };
  }, function (t, e, n) {
    var r = n(6),
        o = n(36).f;
    n(47)("getOwnPropertyDescriptor", function () {
      return function t(e, n) {
        return o(r(e), n);
      };
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(98),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(99), t.exports = n(1).Object.setPrototypeOf;
  }, function (t, e, n) {
    var r = n(2);
    r(r.S, "Object", {
      setPrototypeOf: n(100).set
    });
  }, function (t, e, n) {
    var r = n(13),
        o = n(12),
        i = function i(t, e) {
      if (o(t), !r(e) && null !== e) throw TypeError(e + ": can't set as prototype!");
    };

    t.exports = {
      set: Object.setPrototypeOf || ("__proto__" in {} ? function (t, e, r) {
        try {
          r = n(42)(Function.call, n(36).f(Object.prototype, "__proto__").set, 2), r(t, []), e = !(t instanceof Array);
        } catch (t) {
          e = !0;
        }

        return function t(n, o) {
          return i(n, o), e ? n.__proto__ = o : r(n, o), n;
        };
      }({}, !1) : void 0),
      check: i
    };
  }, function (t, e, n) {
    t.exports = {
      default: n(102),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(103);
    var r = n(1).Object;

    t.exports = function t(e, n) {
      return r.create(e, n);
    };
  }, function (t, e, n) {
    var r = n(2);
    r(r.S, "Object", {
      create: n(29)
    });
  }, function (t, e, n) {
    t.exports = {
      default: n(105),
      __esModule: !0
    };
  }, function (t, e, n) {
    n(106), t.exports = parseInt;
  }, function (t, e, n) {
    var r = n(2),
        o = n(107);
    r(r.S + r.F * (Number.parseInt != o), "Number", {
      parseInt: o
    });
  }, function (t, e, n) {
    var r = n(0).parseInt,
        o = n(108).trim,
        i = n(56),
        a = /^[-+]?0[xX]/;
    t.exports = 8 !== r(i + "08") || 22 !== r(i + "0x16") ? function t(e, n) {
      var i = o(String(e), 3);
      return r(i, n >>> 0 || (a.test(i) ? 16 : 10));
    } : r;
  }, function (t, e, n) {
    var r = n(2),
        o = n(17),
        i = n(10),
        a = n(56),
        u = "[" + a + "]",
        l = "​",
        c = RegExp("^" + u + u + "*"),
        s = RegExp(u + u + "*$"),
        f = function f(t, e, n) {
      var o = {},
          u = i(function () {
        return !!a[t]() || l[t]() != l;
      }),
          c = o[t] = u ? e(p) : a[t];
      n && (o[n] = c), r(r.P + r.F * u, "String", o);
    },
        p = f.trim = function (t, e) {
      return t = String(o(t)), 1 & e && (t = t.replace(c, "")), 2 & e && (t = t.replace(s, "")), t;
    };

    t.exports = f;
  }, function (t, e, n) {
    "use strict";

    function r(t) {
      return t && t.__esModule ? t : {
        default: t
      };
    }

    Object.defineProperty(e, "__esModule", {
      value: !0
    });

    var o = n(14),
        i = r(o),
        a = n(7),
        u = r(a),
        l = n(15),
        c = r(l),
        s = n(19),
        f = r(s),
        p = n(20),
        d = r(p),
        h = n(21),
        b = r(h),
        v = n(8),
        g = r(v),
        y = n(37),
        m = r(y),
        _ = n(55),
        x = r(_),
        A = n(22),
        w = r(A),
        k = g.default.import("blots/container"),
        O = g.default.import("parchment"),
        j = function (t) {
      function e() {
        return (0, u.default)(this, e), (0, f.default)(this, (e.__proto__ || (0, i.default)(e)).apply(this, arguments));
      }

      return (0, b.default)(e, t), (0, c.default)(e, [{
        key: "format",
        value: function t() {
          this.getAttribute("table_id");
        }
      }, {
        key: "optimize",
        value: function t(n) {
          (0, d.default)(e.prototype.__proto__ || (0, i.default)(e.prototype), "optimize", this).call(this, n);
          var r = this.next;
          null != r && r.prev === this && r.statics.blotName === this.statics.blotName && r.domNode.tagName === this.domNode.tagName && r.domNode.getAttribute("table_id") === this.domNode.getAttribute("table_id") && (r.moveChildren(this), r.remove());
        }
      }, {
        key: "insertBefore",
        value: function t(n, r) {
          if (null != this.statics.allowedChildren && !this.statics.allowedChildren.some(function (t) {
            return n instanceof t;
          })) {
            var o = O.create(this.statics.defaultChild, m.default.random_id());
            o.appendChild(n), n = o;
          }

          (0, d.default)(e.prototype.__proto__ || (0, i.default)(e.prototype), "insertBefore", this).call(this, n, r);
        }
      }], [{
        key: "create",
        value: function t(n) {
          var r = "table",
              o = (0, d.default)(e.__proto__ || (0, i.default)(e), "create", this).call(this, "table");
          return o.setAttribute("table_id", n), o;
        }
      }]), e;
    }(w.default);

    j.blotName = "table", j.tagName = "table", j.scope = O.Scope.BLOCK_BLOT, j.defaultChild = "tr", j.allowedChildren = [x.default], e.default = j;
  }, function (t, e, n) {
    var r = n(111);
    "string" == typeof r && (r = [[t.i, r, ""]]);
    var o,
        i = {
      hmr: !0
    };
    i.transform = void 0;
    var a = n(113)(r, i);
    r.locals && (t.exports = r.locals);
  }, function (t, e, n) {
    e = t.exports = n(112)(void 0), e.push([t.i, '.ql-editor table {\n    width: 100%;\n    border-collapse: collapse;\n}\n\n.ql-editor table td {\n    border: 1px solid black;\n    padding: 5px;\n    height: 25px;\n}\n\n.ql-formats button.ql-table::after,\n.ql-formats .ql-picker.ql-table .ql-picker-label::before {\n    content: " ";\n    display: block;\n    width: 18px;\n    height: 18px;\n    background-repeat: no-repeat;\n    background-size: contain;\n}\n\n.ql-picker.ql-table .ql-picker-label::before {\n    background-image: url(\'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAABcSURBVEhL3YsxDgBACML8/6fvNhd0aGCyCUuBOsULR5hGToStSHl8oB4fqMcH6rtIRZhGToStSHl8oB4fqMcH6rtIRZhGToStSHl8oB4fqMcH6rtIRZhGTk5Q9QFCcv8BMZAsCwAAAABJRU5ErkJggg==\');\n}\n\nbutton.ql-table[value="append-row"]::after {\n    background-image: url(\'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAC5SURBVEhL7ZNBCsIwFERzKxceQHGjqLcSFMHzKOpN1BOIe53BDgxJCjbRlX3woJnf/F9KEnq6MIE3+KyUPcYw4QpzG0q8wAQVa2nt0w8QfzpgCU/w0XiEc5ij84ANVC2WtRjVEuKLtoP8cs+EZzO4jbLsReP1ZkEvDeHZ1lR4doADW7PHCH4E/zc3tcHa/f1Yxs8H8LSwiRSe7RmUsoDeTHg2ZVDDGnpDdwW/Ao8iT4suGp+Z9dQSwgttSY+8S9IcOwAAAABJRU5ErkJggg==\');\n}\n\nbutton.ql-table[value="append-col"] {\n    padding-top: 0;\n}\n\nbutton.ql-table[value="append-col"]::after {\n    background-image: url(\'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAADXSURBVEhL3ZVLCsJADIbnVi48gOJGUW8lqCuPo6g3UU8g7vX/GQMhnUdmUZR+8MGQyaOUlIbBMYMP+K7InCls5g5TDVPeYDNSXMOb1+FvBuzhKB7b8A5Ywwt8fT3DJaziGbCDkmflXRFJzMEn1w0FHVswkMMWWq5QNxN07MRADlto4fsu3fPuGY9pfj6A2yI5Ok/HjgzksIWWFdTNBB2bM5DDFqbYQt1Qu4FFJLEGV5HbIh8az8X1FLwDDnAcj214B3jzOvQ+oPcfDn+DLEw11DJnAgdPCB8kS4+90nxt3AAAAABJRU5ErkJggg==\');\n}\n\n.ql-table,\n.ql-contain {\n    width: auto !important;\n    margin-right: 0;\n}\n\n.ql-picker.ql-table {\n    font-size: 11px;\n    font-weight: normal;\n}\n\n.ql-picker.ql-table svg {\n    display: none;\n}\n\n.ql-picker.ql-table .ql-picker-label {\n    padding: 2px 3px;\n}\n\n.ql-picker.ql-table .ql-picker-options {\n    width: 178px;\n}\n\n.ql-picker.ql-table .ql-picker-item {\n    display: block;\n    float: left;\n    width: 30px;\n    height: 30px;\n    line-height: 30px;\n    text-align: center;\n    padding: 0px;\n    margin: 1px;\n}\n\n.ql-picker.ql-table .ql-picker-item {\n    border: 1px solid #444;\n    color: #444;\n}\n\n.ql-picker.ql-table .ql-picker-item:hover {\n    border-color: #06c;\n}\n\n.ql-picker-item:nth-child(5):before {\n    clear: both;\n    display: block;\n    content: "";\n    width: 100%;\n}\n\n.ql-picker-item[data-value=newtable_1_1]:before {\n    content: "1x1";\n}\n\n.ql-picker-item[data-value=newtable_1_2]:before {\n    content: "1x2";\n}\n\n.ql-picker-item[data-value=newtable_1_3]:before {\n    content: "1x3";\n}\n\n.ql-picker-item[data-value=newtable_1_4]:before {\n    content: "1x4";\n}\n\n.ql-picker-item[data-value=newtable_1_5]:before {\n    content: "1x5";\n}\n\n.ql-picker-item[data-value=newtable_2_1]:before {\n    content: "2x1";\n}\n\n.ql-picker-item[data-value=newtable_2_2]:before {\n    content: "2x2";\n}\n\n.ql-picker-item[data-value=newtable_2_3]:before {\n    content: "2x3";\n}\n\n.ql-picker-item[data-value=newtable_2_4]:before {\n    content: "2x4";\n}\n\n.ql-picker-item[data-value=newtable_2_5]:before {\n    content: "2x5";\n}\n\n.ql-picker-item[data-value=newtable_3_1]:before {\n    content: "3x1";\n}\n\n.ql-picker-item[data-value=newtable_3_2]:before {\n    content: "3x2";\n}\n\n.ql-picker-item[data-value=newtable_3_3]:before {\n    content: "3x3";\n}\n\n.ql-picker-item[data-value=newtable_3_4]:before {\n    content: "3x4";\n}\n\n.ql-picker-item[data-value=newtable_3_5]:before {\n    content: "3x5";\n}\n\n.ql-picker-item[data-value=newtable_4_1]:before {\n    content: "4x1";\n}\n\n.ql-picker-item[data-value=newtable_4_2]:before {\n    content: "4x2";\n}\n\n.ql-picker-item[data-value=newtable_4_3]:before {\n    content: "4x3";\n}\n\n.ql-picker-item[data-value=newtable_4_4]:before {\n    content: "4x4";\n}\n\n.ql-picker-item[data-value=newtable_4_5]:before {\n    content: "4x5";\n}\n\n.ql-picker-item[data-value=newtable_5_1]:before {\n    content: "5x1";\n}\n\n.ql-picker-item[data-value=newtable_5_2]:before {\n    content: "5x2";\n}\n\n.ql-picker-item[data-value=newtable_5_3]:before {\n    content: "5x3";\n}\n\n.ql-picker-item[data-value=newtable_5_4]:before {\n    content: "5x4";\n}\n\n.ql-picker-item[data-value=newtable_5_5]:before {\n    content: "5x5";\n}\n\n.ql-picker-item[data-value=newtable_6_1]:before {\n    content: "6x1";\n}\n\n.ql-picker-item[data-value=newtable_6_2]:before {\n    content: "6x2";\n}\n\n.ql-picker-item[data-value=newtable_6_3]:before {\n    content: "6x3";\n}\n\n.ql-picker-item[data-value=newtable_6_4]:before {\n    content: "6x4";\n}\n\n.ql-picker-item[data-value=newtable_6_5]:before {\n    content: "6x5";\n}\n\n.ql-picker-item[data-value=newtable_7_1]:before {\n    content: "7x1";\n}\n\n.ql-picker-item[data-value=newtable_7_2]:before {\n    content: "7x2";\n}\n\n.ql-picker-item[data-value=newtable_7_3]:before {\n    content: "7x3";\n}\n\n.ql-picker-item[data-value=newtable_7_4]:before {\n    content: "7x4";\n}\n\n.ql-picker-item[data-value=newtable_7_5]:before {\n    content: "7x5";\n}\n\n.ql-picker-item[data-value=newtable_8_1]:before {\n    content: "8x1";\n}\n\n.ql-picker-item[data-value=newtable_8_2]:before {\n    content: "8x2";\n}\n\n.ql-picker-item[data-value=newtable_8_3]:before {\n    content: "8x3";\n}\n\n.ql-picker-item[data-value=newtable_8_4]:before {\n    content: "8x4";\n}\n\n.ql-picker-item[data-value=newtable_8_5]:before {\n    content: "8x5";\n}\n\n.ql-picker-item[data-value=newtable_9_1]:before {\n    content: "9x1";\n}\n\n.ql-picker-item[data-value=newtable_9_2]:before {\n    content: "9x2";\n}\n\n.ql-picker-item[data-value=newtable_9_3]:before {\n    content: "9x3";\n}\n\n.ql-picker-item[data-value=newtable_9_4]:before {\n    content: "9x4";\n}\n\n.ql-picker-item[data-value=newtable_9_5]:before {\n    content: "9x5";\n}\n\n.ql-picker-item[data-value=newtable_10_1]:before {\n    content: "10x1";\n}\n\n.ql-picker-item[data-value=newtable_10_2]:before {\n    content: "10x2";\n}\n\n.ql-picker-item[data-value=newtable_10_3]:before {\n    content: "10x3";\n}\n\n.ql-picker-item[data-value=newtable_10_4]:before {\n    content: "10x4";\n}\n\n.ql-picker-item[data-value=newtable_10_5]:before {\n    content: "10x5";\n}\n', ""]);
  }, function (t, e) {
    function n(t, e) {
      var n = t[1] || "",
          o = t[3];
      if (!o) return n;

      if (e && "function" == typeof btoa) {
        var i = r(o);
        return [n].concat(o.sources.map(function (t) {
          return "/*# sourceURL=" + o.sourceRoot + t + " */";
        })).concat([i]).join("\n");
      }

      return [n].join("\n");
    }

    function r(t) {
      return "/*# sourceMappingURL=data:application/json;charset=utf-8;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(t)))) + " */";
    }

    t.exports = function (t) {
      var e = [];
      return e.toString = function e() {
        return this.map(function (e) {
          var r = n(e, t);
          return e[2] ? "@media " + e[2] + "{" + r + "}" : r;
        }).join("");
      }, e.i = function (t, n) {
        "string" == typeof t && (t = [[null, t, ""]]);

        for (var r = {}, o = 0; o < this.length; o++) {
          var i = this[o][0];
          "number" == typeof i && (r[i] = !0);
        }

        for (o = 0; o < t.length; o++) {
          var a = t[o];
          "number" == typeof a[0] && r[a[0]] || (n && !a[2] ? a[2] = n : n && (a[2] = "(" + a[2] + ") and (" + n + ")"), e.push(a));
        }
      }, e;
    };
  }, function (t, e, n) {
    function r(t, e) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n],
            o = h[r.id];

        if (o) {
          o.refs++;

          for (var i = 0; i < o.parts.length; i++) {
            o.parts[i](r.parts[i]);
          }

          for (; i < r.parts.length; i++) {
            o.parts.push(s(r.parts[i], e));
          }
        } else {
          for (var a = [], i = 0; i < r.parts.length; i++) {
            a.push(s(r.parts[i], e));
          }

          h[r.id] = {
            id: r.id,
            refs: 1,
            parts: a
          };
        }
      }
    }

    function o(t, e) {
      for (var n = [], r = {}, o = 0; o < t.length; o++) {
        var i = t[o],
            a = e.base ? i[0] + e.base : i[0],
            u = i[1],
            l = i[2],
            c = i[3],
            s = {
          css: u,
          media: l,
          sourceMap: c
        };
        r[a] ? r[a].parts.push(s) : n.push(r[a] = {
          id: a,
          parts: [s]
        });
      }

      return n;
    }

    function i(t, e) {
      var n = g(t.insertInto);
      if (!n) throw new Error("Couldn't find a style target. This probably means that the value for the 'insertInto' parameter is invalid.");
      var r = _[_.length - 1];
      if ("top" === t.insertAt) r ? r.nextSibling ? n.insertBefore(e, r.nextSibling) : n.appendChild(e) : n.insertBefore(e, n.firstChild), _.push(e);else if ("bottom" === t.insertAt) n.appendChild(e);else {
        if ("object" != _typeof(t.insertAt) || !t.insertAt.before) throw new Error("[Style Loader]\n\n Invalid value for parameter 'insertAt' ('options.insertAt') found.\n Must be 'top', 'bottom', or Object.\n (https://github.com/webpack-contrib/style-loader#insertat)\n");
        var o = g(t.insertInto + " " + t.insertAt.before);
        n.insertBefore(e, o);
      }
    }

    function a(t) {
      if (null === t.parentNode) return !1;
      t.parentNode.removeChild(t);

      var e = _.indexOf(t);

      e >= 0 && _.splice(e, 1);
    }

    function u(t) {
      var e = document.createElement("style");
      return t.attrs.type = "text/css", c(e, t.attrs), i(t, e), e;
    }

    function l(t) {
      var e = document.createElement("link");
      return t.attrs.type = "text/css", t.attrs.rel = "stylesheet", c(e, t.attrs), i(t, e), e;
    }

    function c(t, e) {
      Object.keys(e).forEach(function (n) {
        t.setAttribute(n, e[n]);
      });
    }

    function s(t, e) {
      var n, r, o, i;

      if (e.transform && t.css) {
        if (!(i = e.transform(t.css))) return function () {};
        t.css = i;
      }

      if (e.singleton) {
        var c = m++;
        n = y || (y = u(e)), r = f.bind(null, n, c, !1), o = f.bind(null, n, c, !0);
      } else t.sourceMap && "function" == typeof URL && "function" == typeof URL.createObjectURL && "function" == typeof URL.revokeObjectURL && "function" == typeof Blob && "function" == typeof btoa ? (n = l(e), r = d.bind(null, n, e), o = function o() {
        a(n), n.href && URL.revokeObjectURL(n.href);
      }) : (n = u(e), r = p.bind(null, n), o = function o() {
        a(n);
      });

      return r(t), function e(n) {
        if (n) {
          if (n.css === t.css && n.media === t.media && n.sourceMap === t.sourceMap) return;
          r(t = n);
        } else o();
      };
    }

    function f(t, e, n, r) {
      var o = n ? "" : r.css;
      if (t.styleSheet) t.styleSheet.cssText = A(e, o);else {
        var i = document.createTextNode(o),
            a = t.childNodes;
        a[e] && t.removeChild(a[e]), a.length ? t.insertBefore(i, a[e]) : t.appendChild(i);
      }
    }

    function p(t, e) {
      var n = e.css,
          r = e.media;
      if (r && t.setAttribute("media", r), t.styleSheet) t.styleSheet.cssText = n;else {
        for (; t.firstChild;) {
          t.removeChild(t.firstChild);
        }

        t.appendChild(document.createTextNode(n));
      }
    }

    function d(t, e, n) {
      var r = n.css,
          o = n.sourceMap,
          i = void 0 === e.convertToAbsoluteUrls && o;
      (e.convertToAbsoluteUrls || i) && (r = x(r)), o && (r += "\n/*# sourceMappingURL=data:application/json;base64," + btoa(unescape(encodeURIComponent(JSON.stringify(o)))) + " */");
      var a = new Blob([r], {
        type: "text/css"
      }),
          u = t.href;
      t.href = URL.createObjectURL(a), u && URL.revokeObjectURL(u);
    }

    var h = {},
        b = function b(t) {
      var e;
      return function () {
        return void 0 === e && (e = t.apply(this, arguments)), e;
      };
    },
        v = b(function () {
      return window && document && document.all && !window.atob;
    }),
        g = function (t) {
      var e = {};
      return function (n) {
        if (void 0 === e[n]) {
          var r = t.call(this, n);
          if (r instanceof window.HTMLIFrameElement) try {
            r = r.contentDocument.head;
          } catch (t) {
            r = null;
          }
          e[n] = r;
        }

        return e[n];
      };
    }(function (t) {
      return document.querySelector(t);
    }),
        y = null,
        m = 0,
        _ = [],
        x = n(114);

    t.exports = function (t, e) {
      if ("undefined" != typeof DEBUG && DEBUG && "object" != (typeof document === "undefined" ? "undefined" : _typeof(document))) throw new Error("The style-loader cannot be used in a non-browser environment");
      e = e || {}, e.attrs = "object" == _typeof(e.attrs) ? e.attrs : {}, e.singleton || (e.singleton = v()), e.insertInto || (e.insertInto = "head"), e.insertAt || (e.insertAt = "bottom");
      var n = o(t, e);
      return r(n, e), function t(i) {
        for (var a = [], u = 0; u < n.length; u++) {
          var l = n[u],
              c = h[l.id];
          c.refs--, a.push(c);
        }

        if (i) {
          r(o(i, e), e);
        }

        for (var u = 0; u < a.length; u++) {
          var c = a[u];

          if (0 === c.refs) {
            for (var s = 0; s < c.parts.length; s++) {
              c.parts[s]();
            }

            delete h[c.id];
          }
        }
      };
    };

    var A = function () {
      var t = [];
      return function (e, n) {
        return t[e] = n, t.filter(Boolean).join("\n");
      };
    }();
  }, function (t, e) {
    t.exports = function (t) {
      var e = "undefined" != typeof window && window.location;
      if (!e) throw new Error("fixUrls requires window.location");
      if (!t || "string" != typeof t) return t;
      var n = e.protocol + "//" + e.host,
          r = n + e.pathname.replace(/\/[^\/]*$/, "/");
      return t.replace(/url\s*\(((?:[^)(]|\((?:[^)(]+|\([^)(]*\))*\))*)\)/gi, function (t, e) {
        var o = e.trim().replace(/^"(.*)"$/, function (t, e) {
          return e;
        }).replace(/^'(.*)'$/, function (t, e) {
          return e;
        });
        if (/^(#|data:|http:\/\/|https:\/\/|file:\/\/\/)/i.test(o)) return t;
        var i;
        return i = 0 === o.indexOf("//") ? o : 0 === o.indexOf("/") ? n + o : r + o.replace(/^\.\//, ""), "url(" + JSON.stringify(i) + ")";
      });
    };
  }]);
});